module.exports = __webpack_public_path__ + "static/media/kokkaany2.40009b41.avif";